import React, { useCallback } from 'react';
import { getCleanUrl } from 'js/utils/url.util';
import { useNavigate } from 'js/hooks/navigate';

import { useGameConfig } from './hooks';

export const withGameInfo = Wrapped => (props) => {
    const navigate = useNavigate();
    const { code, hideButtons, gameLaunchType, showFavoriteIcon, queryString } = props;
    const { gameUrlFragment } = useGameConfig(code);

    const openGameInfo = useCallback(() => {
        const { prevPath } = window.history.state?.state || {};
        const giPath = 'online-game';
        const state = location.pathname.includes(giPath)
            ? {
                prevPath,
                hideButtons,
                queryString,
                gameLaunchType,
                showFavoriteIcon,
                showBackButton: true
            }
            : {
                hideButtons,
                queryString,
                gameLaunchType,
                showFavoriteIcon,
                prevPath: getCleanUrl()
            };

        navigate(`/${giPath}/${gameUrlFragment}`, state);
    }, [showFavoriteIcon, gameUrlFragment, hideButtons, gameLaunchType, navigate, queryString]);

    return (
        <Wrapped
            {...props}
            openGameInfo={openGameInfo}
        />
    );
};
